<template>
  <div class="images-mosaic list-container" ref="additionalTips"  :class="{'hide-num': isShowNum === 'false', 'rtlEnable': !isRTLEnable === false}"> 
    <VueSlickCarousel v-if="!isRTLEnable" v-bind="settings">
      <slot />
    </VueSlickCarousel> 
    <VueSlickCarouselRtl v-else  :rtl="true" v-bind="settings">
      <slot />
    </VueSlickCarouselRtl> 
  </div>
</template>
<script>
 
import VueSlickCarousel from 'vue-slick-carousel'; 
import VueSlickCarouselRtl from 'vue-slick-carousel-rtl'; 
export default {
  name: 'images-mosaic-additional-tips',
  components: { VueSlickCarousel,VueSlickCarouselRtl },
  props: {
    isShowNum: {
      type: String,
      default: false
    }, 
    navTaggingLabel: { type: [String, Array], required: false, default: '' },
    pageCategory: { type: String, required: false, default: 'page category' },
  },

  data() {
    return {
      isRTLEnable : false,
      settings: {
        'dots': false,
        'arrows': true,
        'infinite': false,
        'speed': 500,
        'slidesToShow': 3,
        'swipe':false,
        'slidesToScroll': 1,
        'initialSlide': 0,
        'touchThreshold': 5,  
        'lazyLoad':'progressive', 
        'responsive': [ 
        {
            breakpoint: 1023,
            settings: {  
              dots: false,
              arrow: true, 
              slidesToShow: 2,
              slidesToScroll: 1,  
              speed: 500,  
              arrows: false,
              initialSlide:0,   
              touchThreshold:5,
              dots: true,
              swipe: true,
              focusOnSelect: true,
              lazyLoad:'progressive',
             
            }
          },
          {
            breakpoint: 768,
            settings: { 
              centerMode:true,
              centerPadding: '25px',
              slidesToShow: 1,
              slidesToScroll: 1, 
              speed: 500, 
              arrows: false,
              initialSlide:0,  
              swipe: true,
              touchThreshold:5,
              dots: true,
              focusOnSelect: true,
              lazyLoad:'progressive',
             
            }
          },
        ]
      }, 
    };
  }, 
  mounted(){
    const additionalTipsWrapper = this.$refs.additionalTips;
    const additionalTipsParentNode = additionalTipsWrapper.parentElement.classList.contains("additional-tips") 
    let elem = document.getElementById('main-container');
      let style = getComputedStyle(elem); 
      let isRTL = style.direction === 'rtl' 
      if(isRTL && additionalTipsParentNode){
        this.isRTLEnable = true;
        console.log("")
        additionalTipsWrapper.parentElement.classList.add("additional-tips-rtl")
        
      }
      else{
        this.isRTLEnable = false;
      }
  },

};
</script> 
<style lang="scss" src="./ImagesMosaicAdditionalTips.scss"></style>
